<template>
  <div class="jackpot">
    <ul class="header">
      <li
        :style="{'background-image': 'url(' + item.logoImg + ')'}"
        v-for="(item,index) in gamePlatformList.slice(0,7)"
        @click="setPlatformIndex(index)"
        :key="item.id"
      >
        {{item.fullName}}
      </li>
      <li class="more"><router-link to="/slots"></router-link></li>
    </ul>
    <div class="section">
      <ul class="game-list">
        <li
          @click="goGame(item)"
          v-for="item in slotGameList"
          :key="item.id"
        >
          <div class="img-wrap">
            <img :src="item.picLink" alt="">
          </div>
          <span class="title">{{item.cnName}}</span>
        </li>
      </ul>
      <!-- <a class="mobile" :href="APP_DOWNLOAD" target="_blank"></a> -->
      <router-link to="/download" class="mobile"></router-link>
      <!-- <a class="app" :href="APP_DOWNLOAD" target="_blank"></a> -->
      <router-link to="/download" class="app"></router-link>
    </div>

  </div>
</template>

<script>
import {slotMixin} from '@/common/mixins'
import {commonApi, common} from '@/common/index'
import {mapState} from 'vuex'
import { APP_DOWNLOAD } from '../../assets/js/domian'

export default {
  name: 'index',
  mixins: [slotMixin],
  watch: {
    gamePlatformList () {
      this.getSlotGameByPlatform()
    },
    nowPlatformIndex () {
      this.getSlotGameByPlatform()
    }
  },
  computed: {
    ...mapState({
      frontType: state => state.frontType,
      isLogin: state => state.isLogin,
      UUID: state => state.UUID
    })
  },
  data () {
    return {
      APP_DOWNLOAD: APP_DOWNLOAD,
      gameType: '1',
      gameList: [],
      nowPlatformCode: '',
      nowPlatformIndex: 0,
      slotGameList: []
    }
  },
  methods: {
    goGame (item) {
      common.jinsha_GoGame(item, this.isLogin, this.UUID)
    },
    setPlatformIndex (index) {
      this.nowPlatformIndex = index
    },
    getSlotGameByPlatform () {
      this.nowPlatformCode = this.gamePlatformList[this.nowPlatformIndex].platformCode

      let params = {
        platformCode: this.nowPlatformCode,
        frontType: this.frontType,
        pageNo: 1,
        pageSize: 12
      }
      commonApi.SLOT.getSlotGameByPlatform(params)
        .then(data => {
          this.slotGameList = data.gameList
        })
        .catch(err => { console.log(err) })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../style/mixins";
.jackpot{@include main-container;
  .header{position: relative;display: block;height: 96px;padding: 16px 27px;background: url("./img/background.png") no-repeat center;
    li{@include no-wrap;font-size: 14px;line-height: 64px;float: left;width: 135px;height: 64px;color: #fff;padding-left: 62px;cursor: pointer;
      background-repeat: no-repeat;background-position:10px center;background-size: auto 30px;
      &:hover{color: red}
    }
    .more{    position: absolute;top: 16px;right: 0;width: 27px;height: 64px;padding: 0;
      a{    display: block;height: 100%;}
    }
  }
  .section{overflow: hidden;
    .game-list{float: left;display: inline-block;width: 740px;height: 499px;background: url("./img/background1.png") no-repeat center top;background-size: cover;
      li{cursor: pointer;padding: 1px;display: inline-block;position: relative;width: 150px;height: 131px;margin: 17px;background: #120a08 no-repeat center top;
        &:before{    content: none;position: absolute;top: 0;left: 0;width: 150px;height: 131px;background: url("./img/mask.png")}
        &:hover{&:before{content: ''}}
        .img-wrap{height: 100px;text-align: center;overflow: hidden;
          img{vertical-align: top;height: 100%;width: 100%;}
        }
        .title{@include no-wrap;position: absolute;bottom: 0;left: 0;width: 100%;height: 32px;padding-right: 70px;color: #fff;font-size: 12px;line-height: 32px;text-align: right;
          &:after{    content: '';position: absolute;top: 10px;right: 9px;width: 55px;height: 10px;
            background: url("./img/star.png");
          }
        }
      }
    }
    .mobile{
      display: block;
      float: right;
      width: 215px;
      height: 447px;
      margin-right: 15px;
      background: url("./img/mobile.png") no-repeat center top/100% 100%;
    }
    .app{
      display: block;
      float: right;
      width: 215px;
      height: 48px;
      margin: 0 15px 0 0;
      background: url("./img/app.png") no-repeat center top;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/build901/components/jackpot/index.vue